var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choose-title-stage"},[_c('app-filter',{attrs:{"filter-list":_vm.table_filter},on:{"search":_vm.search}}),_c('app-table',{ref:"table",attrs:{"table-key":_vm.table_key,"tablep":_vm.table_params,"is-row-click":false,"get-data":_vm.getTitleList,"check":true},on:{"select-tr":_vm.onSelectionChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }